import * as React from "react";
const SvgFiRrChessQueenAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 18h-.316a44 44 0 0 1-2.615-10H17a1 1 0 1 0 0-2h-.472s1.281-2.214 1.294-2.245a1.942 1.942 0 0 0-2.864-2.4l-.677.364s-.82-1.085-.849-1.12a2.045 2.045 0 0 0-2.864 0c-.029.03-.849 1.11-.849 1.11l-.677-.36a1.942 1.942 0 0 0-2.864 2.4C6.191 3.787 7.472 6 7.472 6H7a1 1 0 1 0 0 2h.931a44 44 0 0 1-2.615 10H5a3 3 0 0 0 0 6h14a3 3 0 0 0 0-6M9.526 3.88A1 1 0 0 0 10.8 3.6L12 2.013 13.2 3.6a1 1 0 0 0 1.272.277l1.409-.758-1.666 2.88h-4.43L8.11 3.12zM9.939 8h4.122a43 43 0 0 0 2.487 10h-9.1A43 43 0 0 0 9.939 8M19 22H5a1 1 0 1 1 0-2h14a1 1 0 0 1 0 2"
    />
  </svg>
);
export default SvgFiRrChessQueenAlt;
